export const JSON_RPC_URL = 'https://rpc.ankr.com/gnosis'
export const CHAIN_ID = 100
export const CONTRACT_ADDRESS = '0x84270D71C516886E56F5219aE0A365c22A68050f'
